

<!-- 门店管理 -->

<template>
  <div id="madministra">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#madministra {
  height: 100%;
}
</style>
